module.exports = __webpack_public_path__ + "img/20220219_072802.f78d9b51.jpg";